module.exports = __webpack_public_path__ + "static/media/9-2.fe171a4b.mp3";